import React from 'react';
import LegalPage, { LegalSection, LegalStatement, LegalList } from '../components/LegalPage';

const Terms: React.FC = () => {
  return (
    <LegalPage
      title="Terms of Service"
      lastUpdated="June 13, 2026"
      intro="These Terms of Service govern your access to and use of BlockBoard. By creating an account or using the platform, you agree to these terms."
    >
      <LegalSection title="1. What BlockBoard Is">
        <LegalStatement>
          BlockBoard is a software platform that provides communication, document management,
          vendor management, issue tracking, and community management tools. BlockBoard is not a
          property manager, financial institution, law firm, tenant screening service, or
          compliance provider.
        </LegalStatement>
      </LegalSection>

      <LegalSection title="2. Your Responsibilities">
        <LegalStatement>
          Users are solely responsible for complying with all applicable federal, state, local,
          HOA, landlord-tenant, and property management laws and regulations.
        </LegalStatement>
        <p>
          You are responsible for the accuracy of the information you enter, for how you use the
          documents and communications you generate, and for maintaining the confidentiality of
          your account credentials.
        </p>
      </LegalSection>

      <LegalSection title="3. No Legal or Compliance Guarantee">
        <LegalStatement>
          BlockBoard does not guarantee legal compliance for notices, violations, evictions, rent
          collection, lease administration, or HOA governance activities.
        </LegalStatement>
        <p>
          Documents and notices generated through BlockBoard are workflow tools only. You should
          consult qualified legal counsel for matters involving legal notices, deadlines, delivery
          requirements, and dispute resolution.
        </p>
      </LegalSection>

      <LegalSection title="4. Payments">
        <LegalStatement>
          BlockBoard does not hold, transfer, or manage customer funds. Payment processing is
          handled by third-party payment providers.
        </LegalStatement>
        <p>
          When you connect a payment provider, your relationship for the movement of funds is with
          that provider and is subject to their terms. BlockBoard facilitates the workflow but is
          not a party to the underlying financial transaction.
        </p>
      </LegalSection>

      <LegalSection title="5. Subscriptions & Trials">
        <LegalList
          items={[
            'New property manager and HOA accounts start with a 14-day free trial.',
            'A paid subscription is required to continue using BlockBoard after the trial ends.',
            'You may cancel at any time; plan changes are prorated where applicable.',
          ]}
        />
      </LegalSection>

      <LegalSection title="6. Acceptable Use">
        <p>
          You agree not to misuse the platform, attempt to access data belonging to other
          communities, or use BlockBoard for any unlawful purpose. We may suspend accounts that
          violate these terms.
        </p>
      </LegalSection>

      <LegalSection title="7. Changes to These Terms">
        <p>
          We may update these terms from time to time. Continued use of BlockBoard after changes
          take effect constitutes acceptance of the updated terms.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default Terms;
